/* tslint:disable */
/* eslint-disable */
/**
 * Veritable
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 7.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { GetPaginatedServiceLocationDetails200Response } from '../models';
// @ts-ignore
import type { ServiceLocationPatchModel } from '../models';
// @ts-ignore
import type { ServiceLocationPostModel } from '../models';
// @ts-ignore
import type { ServiceLocationResponseModel } from '../models';
// @ts-ignore
import type { ServicelocationSearchModel } from '../models';
/**
 * ServiceLocationDetailsApi - axios parameter creator
 * @export
 */
export const ServiceLocationDetailsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete a service location details by its ID
         * @summary Delete a service location details
         * @param {string} serviceLocationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteServiceLocationDetails: async (serviceLocationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceLocationId' is not null or undefined
            assertParamExists('deleteServiceLocationDetails', 'serviceLocationId', serviceLocationId)
            const localVarPath = `/api/v1/serviceLocation/{serviceLocationId}`
                .replace(`{${"serviceLocationId"}}`, encodeURIComponent(String(serviceLocationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch paginated service location details based on provided filters
         * @summary Get paginated service location details
         * @param {ServicelocationSearchModel} servicelocationSearchModel 
         * @param {boolean} [allLocations] 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaginatedServiceLocationDetails: async (servicelocationSearchModel: ServicelocationSearchModel, allLocations?: boolean, pgNum?: number, pgSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'servicelocationSearchModel' is not null or undefined
            assertParamExists('getPaginatedServiceLocationDetails', 'servicelocationSearchModel', servicelocationSearchModel)
            const localVarPath = `/api/v1/serviceLocation/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (allLocations !== undefined) {
                localVarQueryParameter['allLocations'] = allLocations;
            }

            if (pgNum !== undefined) {
                localVarQueryParameter['pg_num'] = pgNum;
            }

            if (pgSize !== undefined) {
                localVarQueryParameter['pg_size'] = pgSize;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(servicelocationSearchModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch service location details by its ID
         * @summary Get service location details by ID
         * @param {string} serviceLocationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceLocationDetailsByID: async (serviceLocationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceLocationId' is not null or undefined
            assertParamExists('getServiceLocationDetailsByID', 'serviceLocationId', serviceLocationId)
            const localVarPath = `/api/v1/serviceLocation/{serviceLocationId}`
                .replace(`{${"serviceLocationId"}}`, encodeURIComponent(String(serviceLocationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Partially update service location details by its ID
         * @summary Partially update a service location details
         * @param {string} serviceLocationId 
         * @param {ServiceLocationPatchModel} serviceLocationPatchModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchServiceLocationDetails: async (serviceLocationId: string, serviceLocationPatchModel: ServiceLocationPatchModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceLocationId' is not null or undefined
            assertParamExists('patchServiceLocationDetails', 'serviceLocationId', serviceLocationId)
            // verify required parameter 'serviceLocationPatchModel' is not null or undefined
            assertParamExists('patchServiceLocationDetails', 'serviceLocationPatchModel', serviceLocationPatchModel)
            const localVarPath = `/api/v1/serviceLocation/{serviceLocationId}`
                .replace(`{${"serviceLocationId"}}`, encodeURIComponent(String(serviceLocationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serviceLocationPatchModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new service location details entry
         * @summary Add a new service location details
         * @param {ServiceLocationPostModel} serviceLocationPostModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postServiceLocationDetails: async (serviceLocationPostModel: ServiceLocationPostModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceLocationPostModel' is not null or undefined
            assertParamExists('postServiceLocationDetails', 'serviceLocationPostModel', serviceLocationPostModel)
            const localVarPath = `/api/v1/serviceLocation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serviceLocationPostModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ServiceLocationDetailsApi - functional programming interface
 * @export
 */
export const ServiceLocationDetailsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ServiceLocationDetailsApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete a service location details by its ID
         * @summary Delete a service location details
         * @param {string} serviceLocationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteServiceLocationDetails(serviceLocationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteServiceLocationDetails(serviceLocationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceLocationDetailsApi.deleteServiceLocationDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch paginated service location details based on provided filters
         * @summary Get paginated service location details
         * @param {ServicelocationSearchModel} servicelocationSearchModel 
         * @param {boolean} [allLocations] 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaginatedServiceLocationDetails(servicelocationSearchModel: ServicelocationSearchModel, allLocations?: boolean, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPaginatedServiceLocationDetails200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaginatedServiceLocationDetails(servicelocationSearchModel, allLocations, pgNum, pgSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceLocationDetailsApi.getPaginatedServiceLocationDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch service location details by its ID
         * @summary Get service location details by ID
         * @param {string} serviceLocationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServiceLocationDetailsByID(serviceLocationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceLocationResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServiceLocationDetailsByID(serviceLocationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceLocationDetailsApi.getServiceLocationDetailsByID']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Partially update service location details by its ID
         * @summary Partially update a service location details
         * @param {string} serviceLocationId 
         * @param {ServiceLocationPatchModel} serviceLocationPatchModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchServiceLocationDetails(serviceLocationId: string, serviceLocationPatchModel: ServiceLocationPatchModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchServiceLocationDetails(serviceLocationId, serviceLocationPatchModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceLocationDetailsApi.patchServiceLocationDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new service location details entry
         * @summary Add a new service location details
         * @param {ServiceLocationPostModel} serviceLocationPostModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postServiceLocationDetails(serviceLocationPostModel: ServiceLocationPostModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceLocationResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postServiceLocationDetails(serviceLocationPostModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceLocationDetailsApi.postServiceLocationDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ServiceLocationDetailsApi - factory interface
 * @export
 */
export const ServiceLocationDetailsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ServiceLocationDetailsApiFp(configuration)
    return {
        /**
         * Delete a service location details by its ID
         * @summary Delete a service location details
         * @param {ServiceLocationDetailsApiDeleteServiceLocationDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteServiceLocationDetails(requestParameters: ServiceLocationDetailsApiDeleteServiceLocationDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteServiceLocationDetails(requestParameters.serviceLocationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch paginated service location details based on provided filters
         * @summary Get paginated service location details
         * @param {ServiceLocationDetailsApiGetPaginatedServiceLocationDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaginatedServiceLocationDetails(requestParameters: ServiceLocationDetailsApiGetPaginatedServiceLocationDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetPaginatedServiceLocationDetails200Response> {
            return localVarFp.getPaginatedServiceLocationDetails(requestParameters.servicelocationSearchModel, requestParameters.allLocations, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch service location details by its ID
         * @summary Get service location details by ID
         * @param {ServiceLocationDetailsApiGetServiceLocationDetailsByIDRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceLocationDetailsByID(requestParameters: ServiceLocationDetailsApiGetServiceLocationDetailsByIDRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServiceLocationResponseModel> {
            return localVarFp.getServiceLocationDetailsByID(requestParameters.serviceLocationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Partially update service location details by its ID
         * @summary Partially update a service location details
         * @param {ServiceLocationDetailsApiPatchServiceLocationDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchServiceLocationDetails(requestParameters: ServiceLocationDetailsApiPatchServiceLocationDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.patchServiceLocationDetails(requestParameters.serviceLocationId, requestParameters.serviceLocationPatchModel, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new service location details entry
         * @summary Add a new service location details
         * @param {ServiceLocationDetailsApiPostServiceLocationDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postServiceLocationDetails(requestParameters: ServiceLocationDetailsApiPostServiceLocationDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServiceLocationResponseModel> {
            return localVarFp.postServiceLocationDetails(requestParameters.serviceLocationPostModel, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ServiceLocationDetailsApi - interface
 * @export
 * @interface ServiceLocationDetailsApi
 */
export interface ServiceLocationDetailsApiInterface {
    /**
     * Delete a service location details by its ID
     * @summary Delete a service location details
     * @param {ServiceLocationDetailsApiDeleteServiceLocationDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceLocationDetailsApiInterface
     */
    deleteServiceLocationDetails(requestParameters: ServiceLocationDetailsApiDeleteServiceLocationDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Fetch paginated service location details based on provided filters
     * @summary Get paginated service location details
     * @param {ServiceLocationDetailsApiGetPaginatedServiceLocationDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceLocationDetailsApiInterface
     */
    getPaginatedServiceLocationDetails(requestParameters: ServiceLocationDetailsApiGetPaginatedServiceLocationDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetPaginatedServiceLocationDetails200Response>;

    /**
     * Fetch service location details by its ID
     * @summary Get service location details by ID
     * @param {ServiceLocationDetailsApiGetServiceLocationDetailsByIDRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceLocationDetailsApiInterface
     */
    getServiceLocationDetailsByID(requestParameters: ServiceLocationDetailsApiGetServiceLocationDetailsByIDRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServiceLocationResponseModel>;

    /**
     * Partially update service location details by its ID
     * @summary Partially update a service location details
     * @param {ServiceLocationDetailsApiPatchServiceLocationDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceLocationDetailsApiInterface
     */
    patchServiceLocationDetails(requestParameters: ServiceLocationDetailsApiPatchServiceLocationDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Create a new service location details entry
     * @summary Add a new service location details
     * @param {ServiceLocationDetailsApiPostServiceLocationDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceLocationDetailsApiInterface
     */
    postServiceLocationDetails(requestParameters: ServiceLocationDetailsApiPostServiceLocationDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServiceLocationResponseModel>;

}

/**
 * Request parameters for deleteServiceLocationDetails operation in ServiceLocationDetailsApi.
 * @export
 * @interface ServiceLocationDetailsApiDeleteServiceLocationDetailsRequest
 */
export interface ServiceLocationDetailsApiDeleteServiceLocationDetailsRequest {
    /**
     * 
     * @type {string}
     * @memberof ServiceLocationDetailsApiDeleteServiceLocationDetails
     */
    readonly serviceLocationId: string
}

/**
 * Request parameters for getPaginatedServiceLocationDetails operation in ServiceLocationDetailsApi.
 * @export
 * @interface ServiceLocationDetailsApiGetPaginatedServiceLocationDetailsRequest
 */
export interface ServiceLocationDetailsApiGetPaginatedServiceLocationDetailsRequest {
    /**
     * 
     * @type {ServicelocationSearchModel}
     * @memberof ServiceLocationDetailsApiGetPaginatedServiceLocationDetails
     */
    readonly servicelocationSearchModel: ServicelocationSearchModel

    /**
     * 
     * @type {boolean}
     * @memberof ServiceLocationDetailsApiGetPaginatedServiceLocationDetails
     */
    readonly allLocations?: boolean

    /**
     * 
     * @type {number}
     * @memberof ServiceLocationDetailsApiGetPaginatedServiceLocationDetails
     */
    readonly pgNum?: number

    /**
     * 
     * @type {number}
     * @memberof ServiceLocationDetailsApiGetPaginatedServiceLocationDetails
     */
    readonly pgSize?: number
}

/**
 * Request parameters for getServiceLocationDetailsByID operation in ServiceLocationDetailsApi.
 * @export
 * @interface ServiceLocationDetailsApiGetServiceLocationDetailsByIDRequest
 */
export interface ServiceLocationDetailsApiGetServiceLocationDetailsByIDRequest {
    /**
     * 
     * @type {string}
     * @memberof ServiceLocationDetailsApiGetServiceLocationDetailsByID
     */
    readonly serviceLocationId: string
}

/**
 * Request parameters for patchServiceLocationDetails operation in ServiceLocationDetailsApi.
 * @export
 * @interface ServiceLocationDetailsApiPatchServiceLocationDetailsRequest
 */
export interface ServiceLocationDetailsApiPatchServiceLocationDetailsRequest {
    /**
     * 
     * @type {string}
     * @memberof ServiceLocationDetailsApiPatchServiceLocationDetails
     */
    readonly serviceLocationId: string

    /**
     * 
     * @type {ServiceLocationPatchModel}
     * @memberof ServiceLocationDetailsApiPatchServiceLocationDetails
     */
    readonly serviceLocationPatchModel: ServiceLocationPatchModel
}

/**
 * Request parameters for postServiceLocationDetails operation in ServiceLocationDetailsApi.
 * @export
 * @interface ServiceLocationDetailsApiPostServiceLocationDetailsRequest
 */
export interface ServiceLocationDetailsApiPostServiceLocationDetailsRequest {
    /**
     * 
     * @type {ServiceLocationPostModel}
     * @memberof ServiceLocationDetailsApiPostServiceLocationDetails
     */
    readonly serviceLocationPostModel: ServiceLocationPostModel
}

/**
 * ServiceLocationDetailsApi - object-oriented interface
 * @export
 * @class ServiceLocationDetailsApi
 * @extends {BaseAPI}
 */
export class ServiceLocationDetailsApi extends BaseAPI implements ServiceLocationDetailsApiInterface {
    /**
     * Delete a service location details by its ID
     * @summary Delete a service location details
     * @param {ServiceLocationDetailsApiDeleteServiceLocationDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceLocationDetailsApi
     */
    public deleteServiceLocationDetails(requestParameters: ServiceLocationDetailsApiDeleteServiceLocationDetailsRequest, options?: RawAxiosRequestConfig) {
        return ServiceLocationDetailsApiFp(this.configuration).deleteServiceLocationDetails(requestParameters.serviceLocationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch paginated service location details based on provided filters
     * @summary Get paginated service location details
     * @param {ServiceLocationDetailsApiGetPaginatedServiceLocationDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceLocationDetailsApi
     */
    public getPaginatedServiceLocationDetails(requestParameters: ServiceLocationDetailsApiGetPaginatedServiceLocationDetailsRequest, options?: RawAxiosRequestConfig) {
        return ServiceLocationDetailsApiFp(this.configuration).getPaginatedServiceLocationDetails(requestParameters.servicelocationSearchModel, requestParameters.allLocations, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch service location details by its ID
     * @summary Get service location details by ID
     * @param {ServiceLocationDetailsApiGetServiceLocationDetailsByIDRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceLocationDetailsApi
     */
    public getServiceLocationDetailsByID(requestParameters: ServiceLocationDetailsApiGetServiceLocationDetailsByIDRequest, options?: RawAxiosRequestConfig) {
        return ServiceLocationDetailsApiFp(this.configuration).getServiceLocationDetailsByID(requestParameters.serviceLocationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Partially update service location details by its ID
     * @summary Partially update a service location details
     * @param {ServiceLocationDetailsApiPatchServiceLocationDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceLocationDetailsApi
     */
    public patchServiceLocationDetails(requestParameters: ServiceLocationDetailsApiPatchServiceLocationDetailsRequest, options?: RawAxiosRequestConfig) {
        return ServiceLocationDetailsApiFp(this.configuration).patchServiceLocationDetails(requestParameters.serviceLocationId, requestParameters.serviceLocationPatchModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new service location details entry
     * @summary Add a new service location details
     * @param {ServiceLocationDetailsApiPostServiceLocationDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceLocationDetailsApi
     */
    public postServiceLocationDetails(requestParameters: ServiceLocationDetailsApiPostServiceLocationDetailsRequest, options?: RawAxiosRequestConfig) {
        return ServiceLocationDetailsApiFp(this.configuration).postServiceLocationDetails(requestParameters.serviceLocationPostModel, options).then((request) => request(this.axios, this.basePath));
    }
}

